import { PLATFORM as PLAT_FORM } from './constants'
import { parseQuery } from '@utils/utils'

const searchParams = new URLSearchParams(location.search)
const urlQuery:any = parseQuery()

/**
 * ua 浏览器 UA 转小写
 */
export const ua = navigator.userAgent.toLowerCase()

/**
* 判断 UA 是安卓平台
*/
export const isAndroid = ():boolean => ua.includes('android')

/**
* 判断 UA 是微信环境
*/
export const isWechat = ():boolean => ua.includes('micromessenger')

/**
* 判断 UA 是钉钉
*/
export const isDingTalk = ():boolean => ua.includes('dingtalk')


/**
* 判断 UA 是小程序环境
*/
export const isMP = ():boolean => isWechat() && ua.includes('miniprogram')

/**
 * @description 目前app平台判断是根据URL参数platform !!!!!
 * @returns Boolean
 */
export const isApp = ():boolean => searchParams.get('platform') == 'app' || urlQuery.platform == 'app'

/**
 * @description 内部app应用平台区分 - Andorid
 * @returns
 */
export const isSelfAndoridOfApp = ():boolean => searchParams.get('visitFrom') == 'android' || urlQuery.visitFrom == 'android'

/**
 *  @description 内部app应用平台区分 - iOS
 * @returns
 */
export const isSelfIOSOfApp = ():boolean =>  searchParams.get('visitFrom') == 'ios' || urlQuery.visitFrom == 'ios'


// 平台
export const getPlatform = ()=>{
  if(isWechat()){
    if(isMP()){
      return PLAT_FORM.WXAPP
    }else{
      return PLAT_FORM.WECHAT
    }
  }else if(isApp()){
    return PLAT_FORM.APP
  }else{
    return PLAT_FORM.WEB
  }
}

// 渠道来源
export const getVisitFrom = () =>{
  if(isApp()){
    if(isSelfAndoridOfApp()){
      return PLAT_FORM.ANDROID
    }else if(isSelfIOSOfApp()){
      return PLAT_FORM.IOS
    }else {
      return PLAT_FORM.APP
    }
  }else if(isWechat()){
    if(isMP()){
      return PLAT_FORM.WXAPP
    }else{
      return PLAT_FORM.WECHAT
    }
  }else {
    return PLAT_FORM.WEB
  }
}
// 供应商固定传2，云商固定传1
export const isWhichMina = ()=> {
  return  urlQuery.isWhichMina === 'business' || isApp() ? 1 : 2
}

// 经销商固定传1
export const isDealer = ()=> {
  return  urlQuery.isDealer === '1'
}

export const platform = getPlatform()
export const PLATFORM = PLAT_FORM
export const dealElInToView = (el, isTop = false) => {
  try {
    if(isAndroid() && el?.target) {
      if(isTop) {
        el?.target.scrollIntoView(true)
        return
      }
      el?.target.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      })
    }
  } catch(e) { console.log('ERROR-', e)}
}






